import { Outlet } from "react-router-dom";
import Header from "@/components/Header.jsx";
import Footer from "@/components/Footer.jsx";
import MobileCartFab from "@/components/MobileCartFab.jsx";

/**
 * Persistent shell so Header/Footer stay mounted across SPA navigations
 * (avoids empty contact/header/footer until a full reload).
 */
export default function MainLayout() {
    return (
        <div className="page">
            <Header />
            <Outlet />
            <Footer />
            <MobileCartFab />
        </div>
    );
}
